export default __webpack_public_path__ + "locales/sq-AL/ResetApplicationDialog.json?hash=0ab30a058d5c2ee127225ee759998619";